import {
  VaccineManufacturerModel,
  IVaccineManufacturerModel,
} from '@common/models/VaccineManufacturerModel';
import { http } from '@common/utils';
import { trackPromise } from 'react-promise-tracker';

export class VaccineManufacturerService {
  private static baseUrl: string = '/api/vaccinemanufacturer/';
  static tags = {
    upsertVaccineManufacturer: 'upsertVaccineManufacturer',
    deleteVaccineManufacturer: 'deleteVaccineManufacturer',
  };

  static upsertVaccineManufacturer = (
    data: IVaccineManufacturerModel,
  ): Promise<VaccineManufacturerModel> => {
    return trackPromise(
      new Promise<VaccineManufacturerModel>((resolve, reject) => {
        http(`${this.baseUrl}`)
          .post<IVaccineManufacturerModel>(data)
          .then((response) => {
            resolve(new VaccineManufacturerModel(response));
          })
          .catch(reject);
      }),
      this.tags.upsertVaccineManufacturer,
    );
  };

  static deleteVaccineManufacturer = (
    vaccineManufacturerId: number,
  ): Promise<boolean> => {
    return trackPromise(
      new Promise<boolean>((resolve, reject) => {
        http(`${this.baseUrl}${vaccineManufacturerId}`)
          .delete()
          .then(() => {
            resolve(true);
          })
          .catch(reject);
      }),
      this.tags.deleteVaccineManufacturer,
    );
  };
}
